import { appContext } from '../../../../AppContext';
import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';
import { JSX } from 'react';
import { PagedResponse } from "@iconics/core";
import { IPackage, ISolutionPackage } from './DataModels';
import { Button, ButtonBar, Card, Dialog, DialogContent, DialogFooter, GridContainer, GridItem, ISelectItem, RightButtons, Select } from '@iconics/components';
import { Validator } from '@iconics/core';

class AddSolutionPackageDialog extends IbssComponent<IProps, IState>
{
    private validator = new Validator(appContext().core.validationOptions);
    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            packages: [],
            packageId: '',
            packageIdError: '',
        };
    }

    public componentDidMount(): void
    {
        this.validator
            .addInput('packageId', () => this.state.packageId, i => this.setState({ packageIdError: i }))
            .isRequired();
    }

    public async componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>): Promise<void>
    {
        if (!prevProps.open && this.props.open)
        {
            await this.handleOpen();
        }
    }

    private async handleOpen(): Promise<void>
    {
        this.setState({ packageId: '' });

        const solutionPackagesData = await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.solutions.byId.packages.get<ISolutionPackage[]>({
            id: this.props.solutionId,
            tenancy: appContext().tenantId,
        });

        const solutionPackageIds = solutionPackagesData.map(i => i.Id);

        const allPackagesData = await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.packages.get<PagedResponse<IPackage[]>>({
            tenancy: appContext().tenantId,
        });

        const packages = allPackagesData.value
            .filter(i => !solutionPackageIds.includes(i.Id))
            .map(i => ({ value: i.Id, label: i.Name }))
            .sort((a, b) => a.label < b.label ? -1 : 1);

        this.setState({ packages: packages });
    }

    private handleCancel(): void
    {
        this.props.onClose();
    }

    private async handleSave(): Promise<void>
    {
        if (!this.validator.validateAll())
        {
            return;
        }
        try
        {
            await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.solutions.byId.addpackage.post({
                tenancy: appContext().tenantId,
                id: this.props.solutionId,
                body: { Package_ID: this.state.packageId }
            });
            this.props.onSave();
        }
        catch (error)
        {
            console.error(error);
        }
    }

    public render(): JSX.Element
    {
        return (
            <Dialog
                isOpen={this.props.open}
                onOpenChange={() => this.handleCancel()}
            >
                <DialogContent>
                    <Card
                        title={this.labels.Platform_EditSolutions_AddPackageTitle}
                        subTitle={this.labels.Platform_EditSolutions_AddPackageTitle}
                    >
                        <GridContainer>
                            <GridItem>
                                <Select
                                    label={this.labels.Platform_Package_Name}
                                    placeholder={this.labels.Platform_Package_Name}
                                    items={this.state.packages}
                                    value={this.state.packageId ? [this.state.packageId] : []}
                                    onSelect={e => this.setState({ packageId: e.value }, () => this.validator.validate('packageId'))}
                                    required
                                    invalid={!!this.state.packageIdError}
                                    invalidMessage={this.state.packageIdError}
                                />
                            </GridItem>
                        </GridContainer>
                    </Card>
                </DialogContent>
                <DialogFooter>
                    <ButtonBar>
                        <RightButtons>
                            <Button
                                styleType='outlined'
                                onClick={() => this.handleCancel()}
                            >
                                {this.labels.Platform_CommonAction_Cancel}
                            </Button>
                            <Button
                                styleType='filled'
                                onClick={() => this.handleSave()}
                                disabled={!this.validator.isValid}
                            >
                                {this.labels.Platform_CommonAction_Add}
                            </Button>
                        </RightButtons>
                    </ButtonBar>
                </DialogFooter>
            </Dialog>
        )
    }
}

export default AddSolutionPackageDialog;

export interface IProps
{
    solutionId: string;
    open: boolean;
    onClose: () => void;
    onSave: () => void;
}

export interface IState
{
    packages: ISelectItem[];
    packageId: string;
    packageIdError: string;
}
